module.exports = __webpack_public_path__ + "img/P8_popup_thumb_2_th.cb1af835.png";